(function () {
  function setIcon(btn, isOpen) {
    var icon = btn.querySelector('.x-ingr-toggle-icon');
    if (icon) icon.textContent = isOpen ? '−' : '+';
    btn.setAttribute('aria-expanded', String(isOpen));
  }
  function close(item) {
    var pop = item.querySelector('.x-ingr-pop');
    var btn = item.querySelector('.x-ingr-toggle');
    if (pop) pop.classList.remove('is-active');
    if (btn) setIcon(btn, false);
    item.classList.remove('is-active');
  }
  function initToggle(wrap) {
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.x-ingr-toggle');
      if (btn) {
        var item = btn.closest('.x-ingr-item');
        var pop = item.querySelector('.x-ingr-pop');
        var isActive = pop.classList.contains('is-active');
        wrap.querySelectorAll('.x-ingr-item.is-active').forEach(function (i) {
          if (i !== item) close(i);
        });
        pop.classList.toggle('is-active', !isActive);
        item.classList.toggle('is-active', !isActive);
        setIcon(btn, !isActive);
        return;
      }
      if (!e.target.closest('.x-ingr-pop')) {
        wrap.querySelectorAll('.x-ingr-item.is-active').forEach(close);
      }
    });
  }
  function scrollRowTo(row, item) {
    var rowRect = row.getBoundingClientRect();
    var itemRect = item.getBoundingClientRect();
    var delta = itemRect.left - rowRect.left;
    row.scrollBy({ left: delta, behavior: 'smooth' });
  }
  function initSlider(wrap) {
    var row = wrap.querySelector('.x-ingr-row');
    var dots = wrap.querySelectorAll('.x-ingr-dot');
    var items = row ? Array.prototype.slice.call(row.querySelectorAll('.x-ingr-item')) : [];
    if (!row || !items.length) return;

    var activeIndex = 0;

    if (dots.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              activeIndex = items.indexOf(entry.target);
              dots.forEach(function (d, i) {
                d.classList.toggle('is-active', i === activeIndex);
              });
            }
          });
        },
        { root: row, threshold: 0.6 }
      );
      items.forEach(function (item) {
        observer.observe(item);
      });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          scrollRowTo(row, items[i]);
        });
      });
    }

    var autoplayEnabled = row.dataset.autoplay === 'true';
    if (!autoplayEnabled) return;

    var speed = (parseFloat(row.dataset.autoplaySpeed) || 4) * 1000;
    var mq = window.matchMedia('(max-width: 767px)');
    var timer = null;
    var resumeTimer = null;

    function goNext() {
      var next = (activeIndex + 1) % items.length;
      scrollRowTo(row, items[next]);
    }
    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    function start() {
      stop();
      if (mq.matches && !document.hidden) {
        timer = setInterval(goNext, speed);
      }
    }
    function pauseThenResume() {
      stop();
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(start, speed);
    }

    row.addEventListener('touchstart', pauseThenResume, { passive: true });
    row.addEventListener('wheel', pauseThenResume, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });
    if (mq.addEventListener) {
      mq.addEventListener('change', start);
    } else if (mq.addListener) {
      mq.addListener(start);
    }

    start();
  }
  document.querySelectorAll('.x-ingr').forEach(function (wrap) {
    if (wrap.dataset.ingrBound) return;
    wrap.dataset.ingrBound = '1';
    initToggle(wrap);
    initSlider(wrap);
  });
})();